import { useGameSessionContext } from '@/modules/game-session/game-session-context';
import { NPCDialog } from '@/modules/town-npc/components/npc-dialog-view';


export function NpcDialogContainer() {
  const { state, actions, refs } = useGameSessionContext();
  const {
    dialogNpc,
    gameState,
    heroQuests,

    heroOnTownTour,
    selectedNPC,
    townTourDialogWs,
    questClaimDisabled,
    interactionNpc,
  } = state;

  if (!dialogNpc) return null;




  return (
    <NPCDialog
      npc={dialogNpc}
      heroQuests={heroQuests}
      heroGold={gameState.hero?.gold ?? 0}
      heroId={gameState.hero?.id ?? 0}
      heroHP={gameState.hero?.hp ?? 0}
      heroMaxHP={gameState.hero?.maxHp ?? 0}
      heroLevel={gameState.hero?.level ?? 1}
      heroPotions={gameState.hero?.potions ?? 0}
      getHeroWorldPosition={() =>
        refs.engineRef.current?.getHeroDisplayWorldPosition() ?? { x: 0, y: 0 }
      }
      onClose={() => {
        if (interactionNpc?.id === dialogNpc.id) {
          actions.handleNPCInteractionDismiss();
        }
        actions.setSelectedNPC(null);
      }}
      onQuestsChanged={actions.refreshHeroQuests}
      onHeroUpdated={actions.handleNPCHeroUpdated}
      onToast={(message, color) => actions.setToast({ message, color })}
      questClaimDisabled={questClaimDisabled}
      townTourWs={heroOnTownTour && selectedNPC ? townTourDialogWs : undefined}
    />
  );
}
